import { api, unwrap } from "@/lib/api";

export type SocialPlatform = "facebook" | "instagram";
export type SocialPostStatus =
	| "draft"
	| "scheduled"
	| "publishing"
	| "published"
	| "failed";

export interface SocialPost {
	id: string;
	platform: SocialPlatform;
	status: SocialPostStatus;
	message: string;
	mediaUrl: string | null;
	linkUrl: string | null;
	productId: string | null;
	externalId: string | null;
	permalink: string | null;
	error: string | null;
	scheduledAt: string | null;
	publishedAt: string | null;
	insights: Record<string, number> | null;
	createdAt: string;
	updatedAt: string;
}

export interface SocialStatus {
	facebook: boolean;
	instagram: boolean;
}

export interface CreateSocialPostInput {
	platforms: SocialPlatform[];
	message: string;
	mediaUrl?: string;
	linkUrl?: string;
	productId?: string;
	scheduledAt?: string;
}

export interface GenerateCaptionInput {
	productId?: string;
	context?: string;
	platform?: SocialPlatform;
	tone?: "promo" | "nouveaute" | "reassort" | "conseil";
}

export const socialApi = {
	status: () => unwrap<SocialStatus>(api.get("/admin/social/status")),
	generateCaption: (dto: GenerateCaptionInput) =>
		unwrap<{ caption: string }>(
			api.post("/admin/social/generate-caption", dto),
		),
	list: (status?: string) =>
		unwrap<SocialPost[]>(
			api.get("/admin/social/posts", { params: status ? { status } : {} }),
		),
	create: (dto: CreateSocialPostInput) =>
		unwrap<SocialPost[]>(api.post("/admin/social/posts", dto)),
	publish: (id: string) =>
		unwrap<SocialPost>(api.post(`/admin/social/posts/${id}/publish`, {})),
	schedule: (id: string, scheduledAt: string) =>
		unwrap<SocialPost>(
			api.post(`/admin/social/posts/${id}/schedule`, { scheduledAt }),
		),
	insights: (id: string) =>
		unwrap<SocialPost>(api.get(`/admin/social/posts/${id}/insights`)),
};
